import {
  MUTATION_MAX_FAILURE_COUNT,
  MUTATION_RETRY_BASE_MS,
  MUTATION_RETRY_MAX_MS,
  OFFLINE_QUEUE_META,
} from './constants';

export function mutationRetryDelay(attempt) {
  const exp = MUTATION_RETRY_BASE_MS * 2 ** Math.max(0, attempt - 1);
  const jitter = Math.floor(Math.random() * 500);
  return Math.min(exp + jitter, MUTATION_RETRY_MAX_MS);
}

export function shouldRetryOfflineMutation(failureCount, error) {
  if (failureCount >= MUTATION_MAX_FAILURE_COUNT) return false;
  const status = error?.status ?? error?.statusCode;
  if (typeof status === 'number' && status >= 400 && status < 500) return false;
  return true;
}

/** Stable defaults object — do not spread createOfflineMutationOptions() on every render. */
export const OFFLINE_MUTATION_DEFAULTS = {
  // Pause when offline (onlineManager false) — do not execute against fetch timeouts.
  networkMode: 'online',
  retry: shouldRetryOfflineMutation,
  retryDelay: mutationRetryDelay,
  gcTime: 1000 * 60 * 60 * 24,
  meta: OFFLINE_QUEUE_META,
};

/** Shared options for durable offline-first writes. */
export function createOfflineMutationOptions(overrides = {}) {
  return {
    ...OFFLINE_MUTATION_DEFAULTS,
    ...overrides,
  };
}
